import { Accordion, Col, Row } from "react-bootstrap";
import React from "react";
import VerBusinessDetails from "../../../components/common/VerBusinessDetails";

type Props = {
  data: any[];
};

const VerCorrBank: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) {
    return <Row>No Correspondent Banks Found</Row>;
  }

  return (
    <>
      <Accordion>
        {data.map((corrBank: any, index: number) => (
          <Accordion.Item key={index} eventKey={`C${index}`}>
            <Accordion.Header>Correspondent Bank {index + 1}</Accordion.Header>

            <Accordion.Body>
              <Row>
                <Col>
                  <VerBusinessDetails
                    label="Bank Name"
                    defaultValue={corrBank.bank_name}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Currency"
                    defaultValue={corrBank.currency_id.currency_code}
                  />
                </Col>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Sort Code"
                    defaultValue={corrBank.sort_code}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <VerBusinessDetails
                    label="IBAN"
                    defaultValue={corrBank.iban}
                  />
                </Col>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Swift Code"
                    defaultValue={corrBank.swift_code}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <VerBusinessDetails
                    label="Bank Account Number"
                    defaultValue={corrBank.bank_account_number}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <VerBusinessDetails
                    label="Is Default Bank"
                    defaultValue={corrBank.is_default_bank ? "Yes" : "No"}
                  />
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};

export default VerCorrBank;
